import { render, staticRenderFns } from "./indicatorTable.vue?vue&type=template&id=56eefd74&scoped=true"
import script from "./indicatorTable.vue?vue&type=script&lang=js"
export * from "./indicatorTable.vue?vue&type=script&lang=js"
import style0 from "./indicatorTable.vue?vue&type=style&index=0&id=56eefd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eefd74",
  null
  
)

export default component.exports